@if (mainFilename$ | async; as mainFilename) {
  <vhv-angebot-v2
    *axLazyElement="'vhv-angebot-v2/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></vhv-angebot-v2>
}
